module.exports = __webpack_public_path__ + "img/7a21f235317b4beaff9548487186667a.png";